import { render, staticRenderFns } from "./TemplateEditor.vue?vue&type=template&id=2307db01&scoped=true"
import script from "./TemplateEditor.vue?vue&type=script&lang=js"
export * from "./TemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./TemplateEditor.vue?vue&type=style&index=0&id=2307db01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2307db01",
  null
  
)

export default component.exports